import { render, staticRenderFns } from "./PlanProject.vue?vue&type=template&id=47b84270&scoped=true"
import script from "./PlanProject.vue?vue&type=script&lang=js"
export * from "./PlanProject.vue?vue&type=script&lang=js"
import style0 from "./PlanProject.vue?vue&type=style&index=0&id=47b84270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b84270",
  null
  
)

export default component.exports